import React from "react";
import { REFUND_OPTIONS } from "~/constants";
import { getLoginServiceData } from "~/cores/appCore";
import OneClickOptionsWrapper, { OneClickTextAndIconOption } from "./OneClickOptions";
import { TurnrModalContent, TurnrModalHeader } from "~/components/modals/TurnrModal";
import CreditCardIcon from "rylak-common/src/icons/CreditCardIcon.jsx";
import GiftCardIcon from "rylak-common/src/icons/GiftCardIcon.jsx";
import { getRefundOptionHeader } from "~/cores/refundCore";

const REFUND_OPTION_ICONS = {
    [REFUND_OPTIONS.BASIC]: CreditCardIcon,
    [REFUND_OPTIONS.GIFT_CARD]: GiftCardIcon,
};

function PaymentMethodStep({ appProps, onBack, onModalClose, onPaymentMethodSave }) {
    const { getLocaleText } = appProps;

    const onClick = function (refundOption) {
        // setSelectedRefundOption(refundOption?.type);
        onPaymentMethodSave(refundOption?.type);
    };

    return (
        <>
            <TurnrModalHeader onBack={onBack} onClose={onModalClose} title={getLocaleText("select-refund-method")} />
            <TurnrModalContent>
                <OneClickOptionsWrapper>
                    {getLoginServiceData(appProps)?.refundOptions.map((refundOption) => {
                        const Icon = REFUND_OPTION_ICONS[refundOption.type];
                        const title = getRefundOptionHeader(refundOption, { appProps });

                        const description = getLocaleText(["confirmation-page.refund-options", refundOption.type, "text"]);

                        return (
                            <OneClickTextAndIconOption
                                dataTestId={`refund-method-${refundOption.type}`}
                                key={refundOption.type}
                                title={title}
                                description={description}
                                Icon={Icon}
                                onClick={() => onClick(refundOption)}
                            />
                        );
                    })}
                </OneClickOptionsWrapper>
            </TurnrModalContent>
        </>
    );
}

export default PaymentMethodStep;
